/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { getStandardDateTime } from '@/utils/getStandardDateTime'

export const showDate = (value: string | Date | null | undefined): string =>
  value ? getStandardDateTime(value instanceof Date ? value.toISOString() : value) : '—'

export const showText = (value: string | number | null | undefined): string =>
  value === null || value === undefined || value === '' ? '—' : String(value)

export const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div>
    <dt className="text-xs uppercase tracking-wide text-base-content/60">{label}</dt>
    <dd className="text-sm">{children}</dd>
  </div>
)
